module.exports = __webpack_public_path__ + "static/media/icon_173.3d0e5432.svg";